<template>
    <v-container fluid fill-height px-0 class="main-container d-block">
        <div class="content-block">
            <HeaderMenu title="История событий" class="mx-6 mb-6" back-page/>
            <v-layout row v-if="deviceData" class="bold-text mx-6 mb-3 w-100 justify-center">
                {{ deviceData.name }}
                <span class="subtitle-text ml-1" v-if="deviceData.location">
                    ({{ deviceData.location }})
                </span>
            </v-layout>
            <v-layout column ma-0 class="main-text mb-5 w-100 motions-list scrollbar-block" v-if="motions.length > 0">
                <v-flex
                    xs12
                    v-for="(motion, index) in motions"
                    :key="index" class="motions"
                    :class="{'motions__high': motion.new_day}"
                >
                    <v-layout v-if="motion.new_day" class="motions__title bold-text">
                        {{motion.new_day}}
                    </v-layout>
                    <v-flex class="motion-row">
                        <div class="motion-row__time">
                            <div class="time-row bold-text d-inline-flex">
                                начало: <span class="main-text">{{motion.start_updated}}</span>
                                <div class="time-row bold-text ml-3">
                                    конец: <span class="main-text">{{motion.end_updated}}</span>
                                </div>
                            </div>
                            <div class="time-row bold-text">длительность: <span class="main-text">{{motion.text_duration}}</span></div>
                        </div>
                    </v-flex>
                </v-flex>
            </v-layout>
            <div class="d-flex align-center motions-list__error" v-else>
                <v-flex class="d-block text-center">
                    <div>
                        <v-img :src="require('@/assets/images/error.svg')" class="d-inline-flex mb-8"/>
                        <div class="common-text text-center">
                            Нет уведомлений
                        </div>
                    </div>
                </v-flex>
            </div>
            <ModalWaiting ref="modalWaiting" title="Загрузка событий" noCancel></ModalWaiting>
        </div>
    </v-container>
</template>

<script>
import HeaderMenu from "@/components/core/HeaderMenu";
import ModalWaiting from "@/components/modals/ModalWaiting";
import {eventBus} from "@/main";
import {getTimeFromDate} from "@/utils";
import {timeWithTZ} from "@/utils";

export default {
    name: "MotionHistory",
    components: {
        HeaderMenu,
        ModalWaiting,
    },
    data() {
        return {
            deviceUID: null,
            deviceData: {},
            motions: [],
        };
    },
    created() {
        eventBus.$on("reconnect", this.loadPage);
    },
    beforeDestroy() {
        eventBus.$off("reconnect", this.loadPage);
    },
    mounted() {
        this.loadPage();
    },
    methods: {
        loadPage() {
            this.deviceUID = this.$route.params.id;
            if (this.deviceUID) {
                this.getMotions();
            }
        },
        getMotions() {
            this.motions = [];
            this.$refs.modalWaiting.open();
            this.$http.get('/devices/guest/motion-history/' + this.deviceUID + '/')
                .then((res) => {
                    this.deviceData = res.data.device;
                    this.motions = res.data.actions;
                    this.motions.forEach((motion, index) => {
                        motion.start_updated = this.getTime(motion.start);
                        motion.end_updated = this.getTime(motion.end);
                        motion.text_duration = this.formattedDuration(motion.duration);
                        if (index > 0) {
                            if (this.checkDay(motion.start) != this.checkDay(this.motions[index - 1].start)) {
                                motion.new_day = this.checkDay(motion.start);
                                motion.new_day = this.reverseDate(motion.new_day);
                            }
                        } else {
                            motion.new_day = this.checkDay(motion.start);
                            motion.new_day = this.reverseDate(motion.new_day);
                        }
                    });
                })
                .finally(() => {
                    this.$refs.modalWaiting.close();
                });
        },
        getTime(time) {
            return getTimeFromDate(time);
        },
        checkDay(day) {
            return timeWithTZ(day).split('T')[0];
        },
        reverseDate(time) {
            const [year, month, day] = time.split("-");
            return day + "." + month + "." + year;
        },
        formattedDuration(val) {
            val = parseInt(val);
            if (val >= 60) {
                let minutes = Math.floor(val / 60);
                let seconds = val % 60;
                let hours = Math.floor(minutes / 60);
                minutes = minutes % 60;
                let row = "";
                if (hours) {
                    row = hours + " ч.";
                }
                if (minutes) {
                    if (hours) {
                        row += " " + minutes + " мин.";
                    }
                    else {
                        row += minutes + " мин.";
                    }
                }
                if (seconds) {
                    if (hours || minutes) {
                        row += " " + seconds + " сек.";
                    } else {
                        row += seconds + " сек.";
                    }
                }
                return row;
            }
            return val + " сек.";
        },
    },
}
</script>

<style lang="scss" scoped>
.motions-list {
    height: calc(100vh - 138px) !important;
    overflow-y: auto;
    padding: 0 24px;

    &::-webkit-scrollbar {
        display: none;
    }

    &__error {
        display: flex;
        height: calc(100% - 56px) !important;
    }

    &__row {
        border-bottom: 1px solid rgba(19, 15, 38, 0.04);
        width: 100%;
        display: flex;
        flex-direction: column;
        padding: 6px 24px;

        &:last-child {
            border: none;
        }
    }

    .motions {
        max-height: 75px;

        &__high {
            max-height: 125px;
        }

        &:not(:last-child) {
            border-bottom: 1px solid #787878;
        }

        &__title {
            margin: 10px 0;
            padding: 4px 0;
            background: #FFFFFF;
            color: #787878;
            justify-content: center;
            border-radius: 30px;
        }

        .motion-row {
            display: flex;
            flex-direction: row;
            align-items: center;
            width: 100%;
            min-height: 44px;
            padding: 4px 0;

            &:not(:last-child) {
                border-bottom: 1px solid #787878;
            }

            &__time {
                display: inline-flex;

                .time-row:not(:first-child) {
                    margin-left: 12px;
                }
            }

            .v-image {
                max-height: 36px;
                max-width: 36px;
            }
        }
    }
}

@media screen and ( max-width: 700px) {
    .motions-list .motions .motion-row__time {
        flex-direction: column;

        .time-row:not(:first-child) {
            margin-left: 0;
        }
    }
}
</style>